import { Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  AfterContentChecked,
  Inject,
  Input,
} from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { OrgDataModel } from '../../../models/orgData.model';
import { LangService } from '../../../services/lang.service';
import { HeaderUserModel } from '../../../models/header-user.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en' }],
})
export class HeaderComponent implements OnInit {
  @Output()
  logout = new EventEmitter();
  @Output()
  login = new EventEmitter();
  @Input() headerTitle = '';
  @Input() signedInUser: HeaderUserModel;
  @Input() orgInfo: OrgDataModel;
  @Input() isBackoffice: boolean;
  @Input() isAccountRegistration: boolean = false;
  constructor(
    public lang: LangService,
    public location: Location,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string
  ) {}

  ngOnInit(): void {}

  setLang(lang: string) {
    this.lang.currentLang = lang;
    this._locale = lang;
    this._adapter.setLocale(this._locale);
  }

  onLogout() {
    this.logout.emit();
  }
  onLogin() {
    this.login.emit();
  }
}
